module.exports = __webpack_public_path__ + "static/media/delete.996938f7.svg";